import { I18n } from 'react-redux-i18n'
import { COMPANY_TYPES } from '../../utils/common'

export const getTemplateTypeName = (type) => {
  switch (type) {
    case COMPANY_TYPES.CORPORATE:
      return I18n.t('preferenceSetting.CORPORATE')
    case COMPANY_TYPES.BANK:
      return I18n.t('preferenceSetting.BANK')
    case COMPANY_TYPES.SECURITIES:
      return I18n.t('preferenceSetting.SERCURITY')
    case COMPANY_TYPES.FUNDS:
      return I18n.t('preferenceSetting.FUND')
    case COMPANY_TYPES.INSURANCE:
      return I18n.t('preferenceSetting.INSURANCE')
    case COMPANY_TYPES.NON_BANK:
      return I18n.t('preferenceSetting.NON_BANK')
    case COMPANY_TYPES.LIFE_INSURANCE:
      return I18n.t('preferenceSetting.LIFE_INSURANCE')
    case COMPANY_TYPES.NON_LIFE_INSURANCE:
      return I18n.t('preferenceSetting.NON_LIFE_INSURANCE')
    default:
      return ''
  }
}

export const mappingApiTemplate = (templates, companyType) => {
  return templates.map((template) => ({ ...template, companyType }))
}
